module.exports = __webpack_public_path__ + "static/media/SellkeyFunction02.9556e142.png";